module.exports = __webpack_public_path__ + "static/media/arrow-down.9e1a0f82.svg";